import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

/** Counts of pipeline entities (from list/detail include) — matches Prisma relation names. */
export type SupplyCasePipelineCount = {
  requisitions: number;
  enquiries: number;
  quotations: number;
  evaluations: number;
  purchaseOrders: number;
  deliveries: number;
  invoices: number;
};

export interface SupplyCase {
  id: number;
  ref?: string | null;
  caseDate?: string | null;
  eta?: string | null;
  vesselId?: number | null;
  vessel?: { id: number; vesselName: string } | null;
  statusId?: number | null;
  status?: { id: number; name: string } | null;
  portId?: number | null;
  port?: { name: string; code?: string | null } | null;
  categoryIds?: number[];
  categories?: { id: number; name: string; abrv: string | null }[];
  description?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  _count?: SupplyCasePipelineCount;
}

export const useSupplyCases = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<SupplyCase> | SupplyCase[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<SupplyCase>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSupplyCase = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<SupplyCase>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
